import {
  FaEnvelope,
  FaPhone,
  FaFacebook,
  FaInstagram,
  FaXTwitter,
  FaLinkedin
} from "react-icons/fa6";

import ClientNavbar from "../components/ClientNavbar";
import Footer from "../components/Footer";

import "../styles/contact.css";

function Contact() {
  return (
    <>
      <ClientNavbar />

      <div className="contact-page">

        <div className="contact-header">

          <h1>Contact Us</h1>

          <p>
            We'd love to hear from you. Reach out using
            any of the channels below.
          </p>

        </div>

        <div className="contact-grid">

          <div className="contact-card">

            <FaEnvelope className="contact-icon" />

            <h2>Email</h2>

            <a href="mailto:jjmzerah@gmail.com">
              jjmzerah@gmail.com
            </a>

          </div>

          <div className="contact-card">

            <FaPhone className="contact-icon" />

            <h2>Phone</h2>

            <a href="tel:+254722563673">
              +254 722563673
            </a>

          </div>

        </div>

        <div className="social-section">

          <h2>Follow Us</h2>

          <div className="social-links">

            <a
              href="https://www.facebook.com/jimmy.mzerah/"
              target="_blank"
              rel="noreferrer"
            >
              <FaFacebook />
            </a>

            <a
              href="https://www.instagram.com/jimmy.mzerah/"
              target="_blank"
              rel="noreferrer"
            >
              <FaInstagram />
            </a>

            <a
              href="https://x.com"
              target="_blank"
              rel="noreferrer"
            >
              <FaXTwitter />
            </a>

            <a
              href="www.linkedin.com/in/jimmy-mzera-85b509334"
              target="_blank"
              rel="noreferrer"
            >
              <FaLinkedin />
            </a>

          </div>

        </div>

      </div>

      <Footer />
    </>
  );
}

export default Contact;